import {Component, ElementRef, HostBinding, Input, ViewChild} from '@angular/core';
import { AnimationController } from '@ionic/angular';

@Component({
  selector: 'collapsible',
  templateUrl: 'collapsible.html',
  styleUrls: ['collapsible.scss'],
})
export class CollapsibleComponent {

  @HostBinding("style.--acc-height")
  public accHeight: string = '0.1px';

  @ViewChild('body', { read: ElementRef }) private body: ElementRef;
  @ViewChild('container', { read: ElementRef }) private container: ElementRef;

  private didExpand: boolean = false;

  public _expanded: boolean = false;

  constructor(
    private animationCtrl: AnimationController,
  ) { }

  @Input() public set expanded(expanded: boolean) {
    console.log("setexp: "+ expanded);
    if ( this._expanded != expanded ) {
      this.accHeight = this.container.nativeElement.offsetHeight + "px";
      setTimeout(() => { this._expanded = expanded });
//      setTimeout(() => { this.toggle(); });
    }
  }

  @Input() public set autoExpand(autoExpand: number) {
    if (autoExpand > 0 ) {
      setTimeout(() => this.checkAutoExpand(), autoExpand);
    }
  }

  public toggle(): void {
/*    console.log("exp: "+ this._expanded);
    this.didExpand = true;

    // // Test
    // if ( this._expanded) {
    //   this.body.nativeElement.style.height = 'auto';
    // } else {
    //   this.body.nativeElement.style.height = '0';
    // }
    const animation = this.animationCtrl.create('toggle-animation')
      .addElement(this.body.nativeElement)
      .duration(400)
      .easing('ease-out');
    const h: number = this.container.nativeElement.offsetHeight;
    if ( this._expanded) {
      animation.fromTo('height', '0px',  h + 'px');
    } else {
      animation.fromTo('height', h + 'px', '0.1px');
    }
    animation
    .play();

    setTimeout(() => {
      // set height to auto again, because inner conten may change size
      if ( this._expanded) {
        this.animationCtrl.create('toggle-animation2')
          .addElement(this.body.nativeElement)
          .duration(10)
          .fromTo('height', h + 'px', 'auto')
          .play();
      }

    }, 410);*/
  }

  private checkAutoExpand(): void {
    if (!this.didExpand && !this._expanded) {
      this._expanded  = true;
      this.toggle();
    }
  }

}
